// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_b4-b";
export var colorBlue = "_b4-8";
export var colorDot = "_b4-0";
export var colorDotLarge = "_b4-2";
export var colorDotSmall = "_b4-1";
export var colorGreen = "_b4-7";
export var colorGrey = "_b4-3";
export var colorOrange = "_b4-5";
export var colorPink = "_b4-a";
export var colorPurple = "_b4-9";
export var colorRed = "_b4-4";
export var colorYellow = "_b4-6";